<template>
    <div class="y-space-4 gird grid-cols-1">
        <data-loader v-if="isLoading == 1"></data-loader>
        <div class="">{{ statusTitle }}</div>
        <div v-if="newStatus">
            This valuation for insurance will be automatically renewed on
            <b>{{ renewDay }} {{ renewMonth }}</b> each year.
        </div>
        <div
            v-if="!newStatus"
            class="mt-4 btn secondary btn-misc"
            @click="toggleState()"
        >
            <span class="mr-2">{{ title }}</span
            ><i class="fas fa-chevron-right"></i>
        </div>
        <div
            v-else
            class="mt-4 text-gray-400 text-xs cursor-pointer"
            @click="toggleState()"
        >
            <span class="mr-2">{{ title }}</span
            ><i class="fas fa-chevron-right"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: Number,
            required: true,
            default: 0,
        },
        certificateId: {
            type: Number,
            required: true,
        },
        renewDay: {
            type: String,
            required: true,
        },
        renewMonth: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            newStatus: 0,
            isLoading: 0,
        };
    },
    mounted() {
        this.newStatus = this.status;
    },
    methods: {
        toggleState() {
            this.isLoading = 1;
            return this.$store
                .dispatch("updateCertificateAutoRenew", {
                    certificate_id: this.certificateId,
                    auto_renew: !this.newStatus,
                })
                .then((res) => {
                    this.newStatus = res.auto_renew;
                    this.isLoading = 0;
                });
        },
    },
    computed: {
        title() {
            return this.newStatus == 0
                ? "Activate Auto Renew"
                : "Deactivate Auto Renew";
        },
        statusTitle() {
            return this.newStatus == 0
                ? "This valuation for insurance renewal is Inactive"
                : "This valuation for insurance renewal is Active";
        },
    },
};
</script>

<style></style>
